export default __webpack_public_path__ + "static/media/junior-java.f01cf488.png";